import { Component, EventEmitter, HostListener, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { StringHelper } from '../../../core/helpers/strings.helper';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { MobileWebViewService } from '../../../core/services/mobile-web-view.service';
import { OnboardingV2Service } from '../../../core/services/onboarding-v2.service';
import { Router } from '@angular/router';
import { ModalOptionsConfig, ModalService } from '../nz-modal-service/modal.service';
import { AlertComponent } from '../alert/alert.component';
import { LivelinessService } from '../../../core/services/liveliness.service';
import { AppConfig } from '../../../shared/config/app-config';
import { IdentityProvider, ProgressTimelineType, SmileIDVerificationType, SmileIdImage } from '../../../kamona/model/kamonal-model';
import { UtilityService } from '../../../core/services/utility.service';
import { Authentication2FAMixpanelSteps, AuthenticationEvents, DataLayerService } from '../../../core/services/data-layer-service.service';
import { AuthenticationType2FA } from '../../../shared/models/authentication-method.enum';
import { EncryptionUtil } from '@mpt-fo/common/shared/utils/encryption.util';
import { LocationHelper } from '@mpt-fo/common/core/helpers/location.helper';
import { LocalStorageService } from '../../../core/services/local-storage.service';
import { OnboardingKycLevel3MixpanelEvents } from '../../../core/models/onboarding/onboarding-v2-model';
import { SettingsService } from '@mpt-fo/common/core/services/settings.service';

@Component({
    selector: 'app-liveliness',
    templateUrl: './liveliness.component.html',
    styleUrls: ['./liveliness.component.scss'],
})
export class LivelinessComponent implements OnInit {
    @Input() identityProvider: string = IdentityProvider.METAMAP;
    @Input() loadingText = 'Loading...';
    @Input() isMobileView;
    @Input() showHeader = false;
    @Input() headerTitle = '';
    @Input() isSubmitting = false;
    @Input() isGettingRef = false;
    @Input() noBottomPadding = false;
    @Input() reference: string;
    @Input() type = '';
    @Input() username = '';
    @Input() businessOwnerId = '';
    @Input() isBrm = false;
    @Input() activationToken = '';
    @Input() livenessPurposeV2 = '';
    @Input() useCachedReference = true;
    @Input() is2FAEnabled = false;
    @ViewChild('faqTemplate', { static: true }) faqTemplate: TemplateRef<any>;

    multipleWebcamsAvailable = false;
    isMetaMapVendor = true;
    showSmileId = false;
    uploadImageLoader = false;
    moveToNextStageLoading = false;
    @Input() validateUsingMetaMap = true;
    runningModal: NzModalRef;
    isMobileWebViewUser: boolean;
    metamapData: any = undefined;
    @Output() nextStepMoved: EventEmitter<any> = new EventEmitter<any>();
    @Output() onGoBack: EventEmitter<any> = new EventEmitter<any>();
    counter = 1;
    timeoutId: any;
    intervalTime = 1000;
    maxIntervalTime = 32000;
    metamapReferenceRetries = 0;
    maximumNoOfRetry = 9;
    cancelled = false;
    breakPoint = 900;
    metaMapApiToken = '';
    isLoadingApiReference = false;
    readonly DEVICE_REGISTRATION = 'DEVICE_REGISTRATION';
    readonly PASSWORD_RESET = 'PASSWORD_RESET';
    readonly PASSWORD_CHANGE = 'PASSWORD_CHANGE';
    readonly USER_PIN_RESET = 'USER_PIN_RESET';
    readonly ACCOUNT_CLOSURE = 'ACCOUNT_CLOSURE';
    readonly PHONE_UPDATE_VERIFICATION = 'PHONE_UPDATE_VERIFICATION';
    readonly EMAIL_ADDRESS_UPDATE_VERIFICATION = 'EMAIL_ADDRESS_UPDATE_VERIFICATION';
    readonly ADDRESS_UPDATE_VERIFICATION = 'ADDRESS_UPDATE_VERIFICATION';
    readonly PROFILE_UPDATE = 'PROFILE_UPDATE';
    readonly STAFF_USER_ONBOARDING = 'STAFF_USER_ONBOARDING';
    readonly STAFF_USER_ONBOARDING_OLD = 'STAFF_USER_ONBOARDING_OLD';
    readonly DATE_OF_BIRTH_UPDATE_VERIFICATION = 'DATE_OF_BIRTH_UPDATE_VERIFICATION';
    readonly FACE_IDENTIFICATION = 'FACE_IDENTIFICATION';
    readonly KYC_LEVEL_THREE_UPGRADE = 'KYC_LEVEL_THREE_UPGRADE';
    readonly NO_IMAGE_ERROR = '404018';
    readonly THREE_FAILURES_ERROR = '401036';
    readonly SUSPENDED_ERROR = '401037';
    readonly VERIFICATION_FAILED = 'Verification Failed';

    readonly faqLinks = {
        SMILE_ID: 'https://support.moniepoint.com/hc/en-us/sections/16453708900125-Face-Authentication-using-SmileID',
        METAMAP: 'https://support.moniepoint.com/hc/en-us/sections/14651717924253-Face-Authentication',
    };

    //countdown
    countDownTime: any;
    interval: number;
    readonly DEFAULT_INTERVAL = 37500;
    countDownInterval: any;
    readonly INTERVAL_INCREMENTAL = 1.2;
    jitteryValue = 120;
    readonly delayInMilliseconds = 30000;
    readonly MAX_META_MAP_VERIFICATION_PERIOD_IN_MINUTES = 4;
    readonly TOTAL_TIME_IN_SEC = 4 * 60;
    readonly SECONDS_MEASUREMENT = 60;
    ProgressTimelineType = ProgressTimelineType;
    loadingLabel = 'ID';
    flowId = '';

    constructor(
        private onboardingService: OnboardingV2Service,
        private mobileService: MobileWebViewService,
        private modalService: ModalService,
        public localStorage: LocalStorageService,
        protected router: Router,
        private livelinessService: LivelinessService,
        public config: AppConfig,
        public utilityService: UtilityService,
        public dataLayerService: DataLayerService,
        private encryptionUtil: EncryptionUtil,
        private locationHelper: LocationHelper,
        public settingsService: SettingsService,
    ) {}

    ngOnInit(): void {
        if (!this.identityProvider) {
            this.identityProvider = IdentityProvider.METAMAP;
        }
        this.setMetaMapVendor();
        this.getMetaMapApiReference();
        this.isMobileWebViewUser = this.mobileService.isMobileWebViewUser();
    }

    @HostListener('window:resize', ['$event'])
    @HostListener('window:load', ['$event'])
    onResize() {
        this.setMobile(window.innerWidth);
    }

    setMobile(browserWidth) {
        this.isMobileView = browserWidth <= this.breakPoint;
    }

    moveNextStage() {
        this.moveToNextStageLoading = true;
        const data = {
            step: 4,
            data: {
                livelinessCheckReference: this.metaMapApiToken,
            },
        };
        this.nextStepMoved.emit(data);
    }

    isStaffUserOnboarding() {
        return this.type === this.STAFF_USER_ONBOARDING || this.type === this.STAFF_USER_ONBOARDING_OLD;
    }

    isKycLevel3Upgrade() {
        return this.type === this.KYC_LEVEL_THREE_UPGRADE;
    }

    createTicket(reference) {
        this.livelinessService.postZendeskTicket(reference).subscribe(
            (res) => {
                this.runningModal?.destroy();
                this.previousStep();
                this.modalService.showSuccess('Ticket Created Successfully', res?.data?.message);
            },
            (error) => {
                this.runningModal?.destroy();
                this.previousStep();
                const msg = StringHelper.getErrorMessageHttpErrorResponse(error);
                this.modalService.showError('Ticket Creation Failed', msg);
            },
        );
    }

    showCustomerSupportModal(message, allowRetry, reference) {
        const config = new ModalOptionsConfig();
        config.className = 'moniepoint-dialog';
        config.nzMaskClosable = true;
        config.nzComponentParams.alertType = 'confirm';
        config.nzComponentParams.callbackName = 'Create Ticket';
        config.nzComponentParams.cancelName = allowRetry ? 'Retry' : 'Cancel';
        config.nzComponentParams.title = this.VERIFICATION_FAILED;
        config.nzComponentParams.message = message;
        if (allowRetry) {
            config.nzComponentParams.messageTemplate = this.faqTemplate;
        }
        config.nzComponentParams.callback = (result) => {
            if (result) {
                this.createTicket(reference);
                return;
            }
            this.runningModal?.destroy();
            this.previousStep();
        };
        this.runningModal = this.modalService.createModal(AlertComponent, config);
    }

    verificationFailed(params?, retry = false) {
        const data = {
            title: params?.title || this.VERIFICATION_FAILED,
            description:
                params?.description || `${this.isMetaMapVendor ? `Meta map` : ` Smile Id`} verification was not completed.` + ' Please try again',
            alertType: 'warning',
            callbackName: 'Retry Verification',
        };
        this.runningModal?.destroy();
        if (!retry) {
            this.onboardingService.handleIncompleteVerification(data, data.description);
        } else {
            // show modal to generate reference on back
            if (this.isStaffUserOnboarding() && this.metamapReferenceRetries === 3) {
                this.modalService.showError('Metamap Verification Failed', 'Metamap verification could not complete');
                this.router.navigateByUrl('/login');
                return;
            }
            const config = new ModalOptionsConfig();
            config.className = 'moniepoint-dialog';
            config.nzMaskClosable = true;
            config.nzComponentParams.title = data.title;
            config.nzComponentParams.data = 'Retry';
            config.nzComponentParams.alertType = 'confirm';
            config.nzComponentParams.callbackName = 'Retry';
            config.nzComponentParams.message = data.description;
            config.nzComponentParams.callback = (result) => {
                if (result) {
                    this.metamapReferenceRetries++;
                    this.getMetaMapApiReference();
                } else if ((this.ACCOUNT_CLOSURE || this.STAFF_USER_ONBOARDING) && !this.reference) {
                    this.previousStep();
                }
            };
            config.nzComponentParams.cancelCallback = () => {
                this.runningModal?.destroy();
            };
            this.runningModal = this.modalService.createModal(AlertComponent, config);
        }
    }

    previousStep() {
        this.nextStepMoved.emit(-1);
    }

    getMetaMapApiReference() {
        this.cancelled = false;
        this.isLoadingApiReference = false;
        if (this.reference != null) {
            this.metamapData = `{"reference": "${this.reference}"}`;
            this.metaMapApiToken = this.reference;
            return;
        }
        if (this.useCachedReference) {
            const ref = this.onboardingService.getSavedMetaMapReference();
            if (ref) {
                this.setMetaDataApiReference(ref);
                return;
            }
        }
        const deviceInformation = this.settingsService.getDeviceInformation();
        const payload = { deviceUniqueIdentifier: deviceInformation?.deviceUniqueIdentifier };
        this.isLoadingApiReference = true;
        let generateReference;
        switch (this.type) {
            case this.ACCOUNT_CLOSURE:
                generateReference = () => this.livelinessService.getAccountClosureMetaMapReference(deviceInformation?.deviceUniqueIdentifier);
                break;
            case this.FACE_IDENTIFICATION:
                generateReference = this.isBrm
                    ? () => this.livelinessService.generateLivelinessReferenceBrm(this.businessOwnerId, this.type, deviceInformation?.deviceUniqueIdentifier)
                    : () => this.livelinessService.generateLivelinessReference(this.type, deviceInformation?.deviceUniqueIdentifier);
                break;
            case this.KYC_LEVEL_THREE_UPGRADE:
                generateReference = () => this.livelinessService.generateLivelinessReferenceFromAuth(this.livenessPurposeV2, payload);
                break;
            case this.PASSWORD_CHANGE: // deprecated
                generateReference = () => this.livelinessService.getChangePasswordMetaMapReference();
                break;
            case this.USER_PIN_RESET: // deprecated
                generateReference = () => this.livelinessService.getResetUserPinMetaMapReference();
                break;
            case this.STAFF_USER_ONBOARDING:
                generateReference = () => this.livelinessService.getStaffOnboardingReference(this.activationToken, this.livenessPurposeV2, deviceInformation?.deviceUniqueIdentifier);
                break;
            case this.STAFF_USER_ONBOARDING_OLD:
            default:
                generateReference = () => this.onboardingService.getMetaMapPersonalInfoReferenceObservable();
                break;
        }
        generateReference().subscribe(
            (res) => {
                this.runningModal?.destroy();
                this.isLoadingApiReference = false;
                this.setMetaDataApiReference(res?.reference);
                if (
                    this.type === this.ACCOUNT_CLOSURE ||
                    this.type === this.STAFF_USER_ONBOARDING ||
                    this.type === this.FACE_IDENTIFICATION ||
                    this.type === this.KYC_LEVEL_THREE_UPGRADE
                ) {
                    this.reference = res?.reference;
                    this.identityProvider = res?.provider || IdentityProvider.METAMAP;
                    this.flowId = res?.flowId;
                    this.setMetaMapVendor();
                    this.dataLayerService.logEventWithData(AuthenticationEvents.initiated, this.getEventData());
                }
            },
            (error) => {
                const err = {
                    description: StringHelper.getErrorMessageHttpErrorResponse(error),
                };
                this.isLoadingApiReference = false;
                this.verificationFailed(err, true);
            },
        );
    }

    setMetaDataApiReference(ref) {
        this.onboardingService.saveMetaMapReference(ref);
        this.metamapData = `{"reference": "${ref}"}`;
        this.metaMapApiToken = ref;
    }

    onCompletion() {
        this.isSubmitting = true;
        this.incrementCounter(1);
    }

    incrementCounter(retries) {
        this.counter = this.counter * 2;
        const delayTime = Math.min(this.counter * 1000, this.maxIntervalTime);
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => {
            this.getMetaMapStatus(this.metaMapApiToken, retries);
        }, delayTime);
    }

    cancel() {
        clearTimeout(this.timeoutId);
        this.isSubmitting = false;
        this.cancelled = true;
        this.counter = 1;
        this.resetLivelinessVendor();
        this.clearRunningIntervals();
    }

    handleIncompleteVerification() {
        this.onboardingService.handleIncompleteVerification();
    }

    getMetaMapStatus(reference: string, retries) {
        if (this.cancelled) {
            this.isSubmitting = false;
            return;
        }
        this.isSubmitting = true;
        let checkStatus;
        switch (this.type) {
            case this.ACCOUNT_CLOSURE:
                checkStatus = (ref) => this.livelinessService.getAccountClosureMetaMapStatus(ref);
                break;
            case this.PHONE_UPDATE_VERIFICATION:
            case this.EMAIL_ADDRESS_UPDATE_VERIFICATION:
            case this.ADDRESS_UPDATE_VERIFICATION:
            case this.DATE_OF_BIRTH_UPDATE_VERIFICATION:
            case this.PROFILE_UPDATE:
                checkStatus = (ref) => this.livelinessService.getProfileUpdateMetaMapStatus(ref);
                break;
            case this.FACE_IDENTIFICATION:
                checkStatus = this.isBrm
                    ? (ref) => this.livelinessService.getLivelinessStatusBrm(ref, this.businessOwnerId, this.type)
                    : (ref) => this.livelinessService.getLivelinessStatus(ref, this.type);
                break;
            case this.PASSWORD_CHANGE:
                checkStatus = this.config.USE_2FA_FLOW_PASSWORD_CHANGE
                    ? (ref) => this.livelinessService.validatReference(ref, this.type)
                    : (ref) => this.livelinessService.getChangePasswordMetaMapStatus(ref);
                break;
            case this.USER_PIN_RESET:
                checkStatus = this.config.USE_2FA_FLOW_USER_PIN_RESET
                    ? (ref) => this.livelinessService.validatReference(ref, this.type)
                    : (ref) => this.livelinessService.getResetUserPinMetaMapStatus(ref);
                break;
            case this.PASSWORD_RESET:
                checkStatus = (ref) => this.livelinessService.postResetPasswordMetaMapStatus(ref, this.username);
                break;
            case this.DEVICE_REGISTRATION:
                checkStatus = this.is2FAEnabled
                    ? (ref) => this.livelinessService.validatReferencePublic(ref, this.type, this.username)
                    : (ref) => this.livelinessService.postDeviceRegistrationMetaMapStatus(ref, this.username);
                break;
            case this.STAFF_USER_ONBOARDING:
                checkStatus = (ref) => this.livelinessService.postStaffOnboardingMetaMapStatus(ref, this.activationToken, this.livenessPurposeV2);
                break;
            case this.KYC_LEVEL_THREE_UPGRADE:
                checkStatus = (ref) => {
                    // Log mixpanel event specific for KYC_LEVEL_3_UPGRADE
                    this.logMixpanelEvent(OnboardingKycLevel3MixpanelEvents.get_kycl3_face_verification_status_initiated, {
                        face_verification_reference: reference,
                        face_verification_status: 'PENDING',
                    });

                    return this.livelinessService.getLivelinessStatus(ref, this.livenessPurposeV2);
                };
                break;
            case this.STAFF_USER_ONBOARDING_OLD:
            default:
                checkStatus = (ref) => this.onboardingService.getMetaMapPersonalLivelinessReferenceStatus(ref);
                break;
        }

        checkStatus(reference).subscribe(
            (res) => {
                // Log mixpanel event specific for KYC_LEVEL_3_UPGRADE
                if (this.isKycLevel3Upgrade()) {
                    this.logMixpanelEvent(OnboardingKycLevel3MixpanelEvents.get_kycl3_face_verification_status_success, {
                        face_verification_reference: reference,
                        face_verification_status: res?.status, // status from API response
                    });
                }

                this.isStaffUserOnboarding() ? this.handleStaffOnboardingStatusResponse(res, retries) : this.handleStatusResponse(res, retries);
            },
            (error) => {
                this.isSubmitting = false;
                this.runningModal?.destroy();
                clearTimeout(this.timeoutId);
                const err = { description: error?.error?.responseMessage || StringHelper.getErrorMessageHttpErrorResponse(error) };
                this.dataLayerService.logEventWithData(
                    AuthenticationEvents.failed,
                    this.getEventData({
                        errorCode: error.error?.code,
                        errorMessage: err.description,
                    }),
                );

                // Log mixpanel event specific for KYC_LEVEL_3_UPGRADE
                if (this.isKycLevel3Upgrade()) {
                    this.logMixpanelEvent(OnboardingKycLevel3MixpanelEvents.get_kycl3_face_verification_status_failed, {
                        face_verification_reference: reference,
                        api_error_code: error.error?.code,
                        api_error_message: err.description,
                    });
                }

                if (this.isSpecialError(error.error?.code) && !this.isStaffUserOnboarding()) {
                    this.showCustomerSupportModal(err.description, error.error?.code === this.THREE_FAILURES_ERROR, reference);
                } else {
                    this.verificationFailed(err);
                    if (!this.isMetaMapVendor) {
                        this.previousStep();
                    }
                }
            },
        );
    }

    isSpecialError(code) {
        return code === this.NO_IMAGE_ERROR || code === this.THREE_FAILURES_ERROR || code === this.SUSPENDED_ERROR;
    }

    async getEventData(errorDetails?: { errorCode?: string; errorMessage: string }, step = '') {
        const geoHeaders = await this.locationHelper.getCoordinates();

        return {
            auth_type: this.is2FAEnabled ? AuthenticationType2FA.TWO_FACTOR_AUTHENTICATION : 'FACE_MATCH_CHECK',
            auth_type_provider: this.identityProvider,
            feature: this.type,
            step: step,
            ...(geoHeaders ? {
                longitude: geoHeaders.longitude,
                latitude: geoHeaders.latitude,
                } : {}),
            ...(errorDetails
                ? {
                      api_error_code: errorDetails.errorCode,
                      api_error_message: errorDetails.errorMessage,
                      error_message: errorDetails.errorMessage,
                  }
                : {}),
        };
    }

    handleStatusResponse(res, retries) {
        if (res?.status === 'SUCCESS') {
            this.isSubmitting = false;
            this.dataLayerService.logEventWithData(AuthenticationEvents.success, this.getEventData());
            this.moveNextStage();
            this.cancel();
        } else if (res?.status === 'FAILED' || (!this.isMetaMapVendor && retries >= this.maximumNoOfRetry)) {
            this.onboardingService.saveMetaMapReference(null);
            this.modalService.showError(this.VERIFICATION_FAILED, 'We were unable to verify your identity');
            this.dataLayerService.logEventWithData(
                AuthenticationEvents.failed,
                this.getEventData({
                    errorMessage: 'Liveliness verification failed',
                }),
            );
            this.cancel();
            this.previousStep();
        } else if (retries >= this.maximumNoOfRetry) {
            this.onboardingService.handleIncompleteVerification();
            this.cancel();
        } else {
            this.incrementCounter(retries + 1);
        }
    }

    staffOnboardingFailed(res) {
        if (this.type === this.STAFF_USER_ONBOARDING) {
            return res?.verified === false;
        }
        if (this.type === this.STAFF_USER_ONBOARDING_OLD) {
            return res?.state === 'VERIFICATION_COMPLETED' && !res?.verified;
        }
    }

    handleStaffOnboardingStatusResponse(res, retries) {
        if (res?.verified) {
            this.isSubmitting = false;
            this.dataLayerService.logEventWithData(AuthenticationEvents.success, this.getEventData());
            this.moveNextStage();
            this.cancel();
            this.dataLayerService.logEventWithData(
                AuthenticationEvents.success,
                this.getEventData(null, Authentication2FAMixpanelSteps.VALIDATE_FACE_MATCH_SUCCESS),
            );
        } else if (this.staffOnboardingFailed(res) || (!this.isMetaMapVendor && retries >= this.maximumNoOfRetry)) {
            this.onboardingService.saveMetaMapReference(null);
            this.verificationFailed();
            this.dataLayerService.logEventWithData(
                AuthenticationEvents.failed,
                this.getEventData(
                    {
                        errorMessage: 'Liveliness verification failed',
                    },
                    Authentication2FAMixpanelSteps.VALIDATE_FACE_MATCH_FAILED,
                ),
            );
            this.cancel();
            this.previousStep();
        } else if (retries >= this.maximumNoOfRetry) {
            this.onboardingService.handleIncompleteVerification();
            this.cancel();
        } else {
            this.incrementCounter(retries + 1);
        }
    }

    isProfileUpdate() {
        return (
            this.type === this.PHONE_UPDATE_VERIFICATION ||
            this.type === this.EMAIL_ADDRESS_UPDATE_VERIFICATION ||
            this.type === this.ADDRESS_UPDATE_VERIFICATION ||
            this.type === this.PROFILE_UPDATE ||
            this.type === this.DATE_OF_BIRTH_UPDATE_VERIFICATION
        );
    }

    getFlowId() {
        if (this.flowId) {
            return this.flowId;
        }
        if (this.isProfileUpdate()) {
            return this.livelinessService.profileUpdateFlowId;
        }
        return this.onboardingService.getLivelinessPersonalFlowId();
    }

    setMetaMapVendor() {
        this.isMetaMapVendor = this.identityProvider === IdentityProvider.SMILE_ID ? false : true;
    }

    handleNonMetaVendors() {
        this.showSmileId = true;
    }

    getHashedJobReference() {
        const jobReference = this.encryptionUtil.generateHashedValue(this.reference, this.config.S_CODE1, this.config.S_CODE2);

        return jobReference;
    }

    getPayload(images: SmileIdImage[]) {
        const jobReference = this.getHashedJobReference();

        return {
            verificationType: SmileIDVerificationType.LIVELINESS,
            images,
            reference: this.reference,
            jobReference,
        };
    }

    handleEmitImage($event: SmileIdImage[]) {
        this.uploadImageLoader = true;
        this.verifyImageFromSmileIdVendor($event);
    }

    verifyImageFromSmileIdVendor(images: SmileIdImage[]) {
        const payload = this.getPayload(images);
        this.loadingText = '';

        // Log mixpanel event specific for KYC_LEVEL_3_UPGRADE
        if (this.isKycLevel3Upgrade()) {
            this.logMixpanelEvent(OnboardingKycLevel3MixpanelEvents.submit_kycl3_face_verification_job_initiated, {
                face_verification_reference: this.reference,
            });
        }
        this.livelinessService.uploadSmileIdImages(payload).subscribe(
            (x) => {
                this.initialize();
                this.onCompletion();
                this.uploadImageLoader = false;
                this.dataLayerService.logEventWithData(
                    AuthenticationEvents.initiated,
                    this.getEventData(null, Authentication2FAMixpanelSteps.VALIDATE_FACE_MATCH_STARTED),
                );

                // Log mixpanel event specific for KYC_LEVEL_3_UPGRADE
                if (this.isKycLevel3Upgrade()) {
                    this.logMixpanelEvent(OnboardingKycLevel3MixpanelEvents.submit_kycl3_face_verification_job_success, {
                        face_verification_reference: this.reference,
                    });
                }
            },
            (error) => {
                this.uploadImageLoader = false;
                this.resetLivelinessVendor();
                const msg = StringHelper.getErrorMessageHttpErrorResponse(error);
                const data = {
                    title: this.VERIFICATION_FAILED,
                    description: msg || 'Verification was not completed.' + ' Please try again',
                    alertType: 'warning',
                    callbackName: 'Retry Verification',
                };
                if (this.isKycLevel3Upgrade()) {
                    // generate new reference when uploadSmileIdImages fail
                    this.reference = null;
                    this.getMetaMapApiReference();

                    // Log mixpanel event specific for KYC_LEVEL_3_UPGRADE
                    this.logMixpanelEvent(OnboardingKycLevel3MixpanelEvents.submit_kycl3_face_verification_job_failed, {
                        face_verification_reference: this.reference,
                        api_error_code: error?.error?.code,
                        api_error_message: msg,
                    });
                }

                this.runningModal?.destroy();
                this.onboardingService.handleIncompleteVerification(data, msg);
            },
        );
    }

    handleVerifyImageFromSmileIdResponse(res) {
        this.isSubmitting = false;
    }

    resetLivelinessVendor() {
        this.showSmileId = false;
    }

    initialize() {
        this.countDownTime = null;
        this.interval = this.DEFAULT_INTERVAL;
        this.startCountDown();
    }
    canHideTimerCount() {
        const isZeroMinutes = this.getRefinedTime(this.countDownTime?.minutes) === 0;
        const isFewSeconds = this.getRefinedTime(this.countDownTime?.seconds) <= 10;
        return isZeroMinutes && isFewSeconds;
    }

    getRefinedTime(time) {
        return time > 0 ? time : 0;
    }

    getCurrentTime() {
        // tslint:disable-next-line:radix
        const second = parseInt(`${this.countDownTime.seconds}`);
        // tslint:disable-next-line:radix
        const minute = parseInt(`${this.countDownTime.minutes}`);
        const minutesToSeconds = minute * this.SECONDS_MEASUREMENT;
        return this.TOTAL_TIME_IN_SEC - (second + minutesToSeconds);
    }

    startCountDown() {
        try {
            const currentDate = new Date();
            const futureDate = new Date(currentDate.getTime() + this.MAX_META_MAP_VERIFICATION_PERIOD_IN_MINUTES * 60000);
            this.countDownTime = this.utilityService.getTimeFromDate(futureDate.getTime());
            this.countDownInterval = setInterval(() => {
                this.countDownTime = this.utilityService.getTimeFromDate(futureDate.getTime());
            }, 1000);
        } catch (err) {
            // do nothing
        }
    }

    getInterval() {
        const interval = this.interval + Math.floor(this.getJitteryValue() * this.INTERVAL_INCREMENTAL);
        this.interval = interval;
        return interval;
    }

    getJitteryValue() {
        const jittery = Math.floor(Math.random() * 520 + this.jitteryValue);
        this.jitteryValue = jittery;
        return jittery;
    }

    clearRunningIntervals() {
        clearInterval(this.countDownInterval);
        this.countDownTime = null;
    }

    cancelLiveLiness() {
        clearTimeout(this.timeoutId);
        this.isSubmitting = false;
        this.counter = 1;
        this.resetLivelinessVendor();
        this.clearRunningIntervals();
    }

    goBack() {
        this.onGoBack.emit();
        this.previousStep();
    }

    logMixpanelEvent(event: string, params?: { [key: string]: string | number | boolean }) {
        const userEventData = this.onboardingService.getKycLvl3MixpanelUserEventData();
        const eventParams = {
            ...userEventData,
            ...(params ?? {}),
        };
        const eventPayload = { ...eventParams, event };

        this.onboardingService.logMixpanelEvent(eventPayload);
    }
}
